const consoleLog = (...arg: any) => {
  process.env.REACT_APP_VERSION !== "prod" && console.log(...arg);
};
export default consoleLog;
